var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.MICEX.value
    ? _c("div", { staticClass: "stock-data" }, [
        _c("div", { staticClass: "stock-data__content-header" }, [
          _c("span", { domProps: { innerHTML: _vm._s(_vm.text.shares) } }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "stock-data__index" }, [_vm._v("MCX: RASP")]),
        _vm._v(" "),
        _c("div", { staticClass: "stock-data__container" }, [
          _c("div", {
            staticClass: "stock-data__price",
            domProps: { innerHTML: _vm._s(_vm.MICEX.value) },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "stock-data__info" }, [
            _c(
              "div",
              { staticClass: "stock-data__difference" },
              [
                _c("span", { staticClass: "stock-data__difference-value" }, [
                  _c("span", {
                    domProps: { innerHTML: _vm._s(_vm.MICEX.change) },
                  }),
                  _vm._v(" ("),
                  _c("span", {
                    domProps: { innerHTML: _vm._s(_vm.MICEX.changedPercent) },
                  }),
                  _vm._v("%)\n                "),
                ]),
                _vm._v(" "),
                _c("z-icon", {
                  attrs: {
                    name: "mini_arrow",
                    dir: _vm.MICEX.percentIsNegative ? "down" : "up",
                    width: "16",
                    height: "16",
                    color: _vm.MICEX.percentIsNegative ? "#bb2532" : "#2D6356",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("span", {
              staticClass: "stock-data__date",
              domProps: { innerHTML: _vm._s(_vm.MICEX.date) },
            }),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }